export default __webpack_public_path__ + "static/media/sell-nft.9713c2ce.png";